import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { useRef, useState, useMemo, useEffect } from 'react';
var defaultState = {
  x: 0,
  y: 0,
  width: 0,
  height: 0,
  top: 0,
  left: 0,
  bottom: 0,
  right: 0
};
var browser = typeof window !== "undefined";

function useResizeObserver() {
  var frameID = useRef(0);
  var ref = useRef(null);

  var _useState = useState(defaultState),
      _useState2 = _slicedToArray(_useState, 2),
      rect = _useState2[0],
      setRect = _useState2[1];

  var observer = useMemo(function () {
    return browser ? new ResizeObserver(function (entries) {
      var entry = entries[0];

      if (entry) {
        cancelAnimationFrame(frameID.current);
        frameID.current = requestAnimationFrame(function () {
          if (ref.current) {
            setRect(entry.contentRect);
          }
        });
      }
    }) : null;
  }, []);
  useEffect(function () {
    if (ref.current) {
      observer.observe(ref.current);
    }

    return function () {
      observer.disconnect();

      if (frameID.current) {
        cancelAnimationFrame(frameID.current);
      }
    };
  }, [ref.current]);
  return [ref, rect];
}

function useElementSize() {
  var _useResizeObserver = useResizeObserver(),
      _useResizeObserver2 = _slicedToArray(_useResizeObserver, 2),
      ref = _useResizeObserver2[0],
      _useResizeObserver2$ = _useResizeObserver2[1],
      width = _useResizeObserver2$.width,
      height = _useResizeObserver2$.height;

  return {
    ref: ref,
    width: width,
    height: height
  };
}

export { useElementSize, useResizeObserver };